module.exports = __webpack_public_path__ + "img/agriculture/square_icon1.28ce5da7.png";